export default __webpack_public_path__ + "images/party-popper-icon.svg";